import type { Account, InventoryResource, Snapshot } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { DynamoConfiguration } from './steps/dynamoConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Encryption } from '../encryption/encryptionComponent';
import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreDynamoState {
  resourceId: string;
  snapshot: Snapshot;
  restoredName?: string;
  writeCapacityUnits?: number;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  regionName?: string;
  tags: Record<string, string>;
  initialTags: Record<string, string>;
  keepOriginalTags?: boolean;
  encryption?: Encryption;
  initialRegionName: string;
}

const restoreDynamoFlow: Step<RestoreDynamoState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'DynamoConfiguration',
      Component: DynamoConfiguration,
    },
  ],
};

export const RestoreDynamoWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<RestoreDynamoState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreDynamoFlow]}
      initialState={{
        initialRegionName: resource.region || 'us-east-1',
        snapshot,
        resourceId: resource.id,
        supportedCloudProviders: [Provider.Aws],
        keepOriginalTags: true,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
      }}
      title={`Restore DynamoDB`}
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
